/**
 * @title addressForm.js: Feature level module
 * @description Address utility module
 */
 define(['address','addressVerification','preauthchargesmodal'], function(address,addressVerification,preauthchargesmodal) {
	var CAddressForm = {
		addressVal : address,
		validationRulesApplied : false,
		// Set of rules used only for address validation
	    // This method should be ran once with initialization
		validationRules : function() {

			if(!CAddressForm.validationRulesApplied){
				
				$.validator.setDefaults({ignore: ".ignoreHide"});
				$.validator.addMethod("companyrequiredcheck", function(value, element) {
				   	if($('#isBDAppVar').val() == 'BD'){
				   		return value != "";
				   	}else{
				   		return true;
				   	}
				}, messages.ERR_INVALID_COMPANY);
				$.validator.addMethod("pobox", function( value, element ) {
					if($('#isBDAppVar').val() == 'BD'){
					var addressBookBool = typeof element.form.addressType[0] !== 'undefined' ?
							element.form.addressType[0].value == 'S' ? true : false : false;
					var poRegex = /^[^a-z]*(((num(ber)?|#) *\d+)|((box|bin|b)[-. \/\\]? *(num(ber)?|#)? *\d+)|((.*[^a-z])?p[ \.]? ?(o|0)[-. \/\\]? *-?((box|bin)|b|(num(ber)?|#)?\d+)([^a-z]|$))|(p(ost)? *(o(ff(ice)?)?)? *((box|bin)|b)? *(num(ber)?|#)? *\d+)|(p *-?\/?(o)? *-?box([^a-z]|$))|post office box)/i;
					var poCheck = element.form.addressType.value == 'S' || addressBookBool
						? !poRegex.test(value) : true;
					return this.optional(element) || poCheck;
					}else{
						return true;
					}
				}, messages.ERR_INVALID_POBOX);
		    	$.validator.addMethod("notEqual", function(value, element, param) {
					return this.optional(element) || value != param;
					}, messages.ERR_INVALID_STATE);
		    	$.validator.addMethod("countryspecificpostalcodePassCountrySelectorModal", function( value, element) {
                    let form = element.form;
                    let country = $(form).find('[name=country]');
                    if (country.val() === undefined){
                        return !COSTCO.CAddressForm.isUS({input: element})
                        ? this.optional(element) || COSTCO.util.POSTAL_CODE_REGEX_CA.test($.trim(value))
                        : this.optional(element) || COSTCO.util.POSTAL_CODE_REGEX_US.test($.trim(value))
                    }
                    return (country.val() != 'US')
                    ? this.optional(element) || COSTCO.util.POSTAL_CODE_REGEX_CA.test($.trim(value))
                    : this.optional(element) || COSTCO.util.POSTAL_CODE_REGEX_US.test($.trim(value));
                }, messages.ERR_ENTER_ZIPCODE);
		    	$.validator.addMethod("hasvalidationerror", function(value, element) {
					return element.getAttribute('hasvalidationerror') == undefined || element.getAttribute('hasvalidationerror') == null || element.getAttribute('hasvalidationerror') == "false"
				}, messages.ERR_INVALID_STATE);
		    	$.validator.addMethod("validateAdditionalTerritories", function(value, element, param) {
                    let form = element.form;
                    let stateCode = $(form).find('[name=state]').val();
                    const additionalBillingStatesCode = CAddressForm.getAdditionalBillingStates();
		    		if(wcs.isPharmacy === "true") {
	                    if(!additionalBillingStatesCode.includes(stateCode)) {
	                    	return true;
	                    } else {
	                    	return false;
	                    }		    		
	                }
		    		if(param == 'S') {                    
	                    if(!additionalBillingStatesCode.includes(stateCode)) {
	                    	return true;
	                    } else {
	                    	return false;
	                    }
		    		} else {
		    			return true;
		    		}
				}, messages.ERR_INVALID_STATE);
		    	$.validator.addMethod("email", function( value, element ) {
					return /^[_a-zA-Z0-9-+]+(\.[_a-zA-Z0-9-+]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,10})$/.test(value.toLowerCase());
				}, messages.JS_VALID_EMAIL);
				$.validator.addMethod("phone", function( value, element ) {
					if (value.startsWith("0") || value.startsWith("1")) {
						return false;
					}
					//Method phone is already used for Patient Insurance phone, when there is an address creation this overrides the old bind
					try{
						if(element && element.id === "insurancePhone"){
	                        return this.optional(element) || /\(?([0-9]{3})\)\s([0-9]{3})\2?([-]?)([0-9]{4})/.test(value);                      
	                    }
					}catch(e){
						console.log(e);
						return true;//if element is empty , no validation required
					}
					return this.optional(element) || /^\(?\d{3}\)?[ -.]?\d{3}[ -.]?\d{4}$/.test(value);
				}, messages.ERR_INVALID_PHONE1);
				$.validator.addMethod("contactPhone", function( value, element ) {
					if (value.startsWith("0") || value.startsWith("1")) {
						return false;
					}
					return this.optional(element) || /^\(?\d{3}\)?[ -.]?\d{3}[ -.]?\d{4}$/.test(value);
				}, messages.ERR_INVALID_PHONE1);
				/** STRY0157080 Require at least ONE alphabet in each of the name fields */
				$.validator.addMethod("firstNameValidation", function( value, element ) {
					return COSTCO.util.ATLEAST_ONE_ALPHABET.test(value);
				}, messages.ERR_INVALID_FNAME);
				$.validator.addMethod("lastNameValidation", function( value, element ) {
					return COSTCO.util.ATLEAST_ONE_ALPHABET.test(value);
				}, messages.ERR_INVALID_LNAME);
				CAddressForm.validationRulesApplied = true;

			}
	    },

	    /**
	     * Uses Jquery Mask plugin to format input. Use cleanVal() instead of val() to get unformatted value
	     */
		maskInput : function(template) {
	    	$(template).find('[name=phone]').unmask().mask('000-000-0000');
	    	$(template).find('#contactPhNo').unmask().mask('000-000-0000');
	    	$(template).find('#contactPhNo-inline').unmask().mask('000-000-0000');
	    	$(template).find('.phoneNumber').unmask().mask('000-000-0000');

	    	if(COSTCO.CAddressForm.isUS({form: template})){
	    		$(template).find('[name=postal]').unmask().mask('00000-0000');
	    	}else{
	    		$(template).find('[name=postal]').unmask().mask('S0S 0S0');
	    	}
	    },
	    /**
	     * Determine if the form or input is should be interpretted as US.
	     * In the case of a form, we look at the select[name=country]. In the case
	     * of a input, we use the data-country attribute to get the value of
	     * a designated select[name=country] which will have the US/CA value,
	     * otherwise we check the lang ID as a last resort.
	     * @param {object} elementsObj - OPTIONAL - Object with the structure
	     * of {form: formElement, input: inputElement}. Pass inputElement must 
	     * contain a data-attribute that maps to the country select to pull the value.
	     */
	    isUS: function(elementsObj){
	    	var $form = elementsObj && elementsObj.form
	    		? $(elementsObj.form): COSTCO.CAddressForm.getForm();
	    	var $input = elementsObj && elementsObj.input
	    		? $(elementsObj.input) : $('');
	    	var country = 'US';

	    	if ($input.data('country')) {
	    		// If passed an input, it needs to have a data-country attribute
	    		// that maps to the country select we want to interogate if we're
	    		// US or not.
	    		var countrySelectId = $input.data('country');
	    		country = $(countrySelectId).val();
	    	} else if ($form.find('[name=country]').val()) {
	    		// Interrogates the form to see if we have a select[name=country] 
	    		// to determine if US
	    		country = $form.find('[name=country]').val()
	    	} else {
	    		// Last resort is to use the lang ID
	    		if (COSTCO.util.getLangId() != -1){
	    			country = 'CA';
	    		}
	    	}

	    	return country == 'US';

	    },

	    createAddressForm : function(obj){
	    	var data;
	    	if(typeof(obj) === 'number'){
	    		var addressJson = address.getAddressJson(obj)[0];
		    	if(addressJson.length == 0)return '';
		    	data = addressJson[0];
	    	}else{
	    		data = obj;
	    	}

	    	return COSTCO.util.tmpl('tmpl_address_form',obj);
	    },
	    /**
	     * 
	     * Function used to setup the data and parameter to open the
	     * Address Form modal.
	     * 
	     * Param
	     * 	type		- 1 character denoting S for Shipping B for Billing
	     *  obj			- can be either address id or the address json object
	     *  orderItemId - order item id that we are trying to edit the address for
	     *  multiAddress	- whether or not the order is multiShipping address
	     * 
	     */
	    editAddress : function(type, obj, orderItemId, multiAddress) {
	    	var data;
	    	if(typeof(obj) === 'number'){
	    		var addressJson = address.getAddressJson(obj, null, type)[0];
		    	data = addressJson;
	    	}else{
	    		data = obj;
	    	}

	    	if(data == null){
	    		data = window['ajaxAddressObject_' + obj];
	    	}
	    	
	    	if (typeof addressOptions === 'undefined') {
	    		addressOptions = {};
	    	}
	    	
	    	if (typeof addressOptions.url === 'undefined') {
	    		addressOptions.url = '/AjaxAddressAddCmd';
	    	}
	    	//need to add mode parameter if url is AjaxManageAddressCmd and doesn't have mode parameter already
	    	else if (addressOptions.url.indexOf('AjaxManageAddressCmd') > -1 && addressOptions.url.indexOf('mode') < 0) {
	    		addressOptions.url = COSTCO.util.makeUrl(addressOptions.url, {mode: 'UPDATE'});
	    	}

	    	if (multiAddress) {
	    		addressOptions.orderItemId = orderItemId;
	    		addressOptions.multiAddress = multiAddress;	    		
	    	}
	    	//National delivery UX change to remove Terms and Condition Modal in Address book for BD US
	    	if($('#isBDAppVar').val() == 'BD' && type=='S' && !COSTCO.util.isNdEnabled()){
	    		CAddressForm.showBusinessDeliveryQuestionnaireModal(type,data,'edit',addressOptions); 
	    	}else{
		    	CAddressForm.openAddressAddModal(type, data, 'edit', addressOptions);
				
	    	}
	    },

	    editAddress_v2 : function(type, obj, orderItemId, multiAddress) {
        var data;
        if(typeof(obj) === 'number'){
          var addressJson = address.getAddressJson(obj, null, type)[0];
          data = addressJson;
        }else{
          data = obj;
        }

        if(data == null){
          data = window['ajaxAddressObject_' + obj];
        }

        if (typeof addressOptions === 'undefined') {
          addressOptions = {};
        }

        if (typeof addressOptions.url === 'undefined') {
          addressOptions.url = '/AjaxAddressAddCmd';
        }
        //need to add mode parameter if url is AjaxManageAddressCmd and doesn't have mode parameter already
        else if (addressOptions.url.indexOf('AjaxManageAddressCmd') > -1 && addressOptions.url.indexOf('mode') < 0) {
          addressOptions.url = COSTCO.util.makeUrl(addressOptions.url, {mode: 'UPDATE'});
        }

        if (multiAddress) {
          addressOptions.orderItemId = orderItemId;
          addressOptions.multiAddress = multiAddress;
        }

        if($('#isBDAppVar').val() == 'BD' && type=='S'){
          CAddressForm.showBusinessDeliveryQuestionnaireModal_v2(type,data,'edit',addressOptions);
        }else{
          CAddressForm.openAddressAddModal_v2(type, data, 'edit', addressOptions);
        }
      },
	    /**
	     * Opens an edit address modal directly on the page (without first opening choose address modal).
	     * 
	     * This is because regularly the address batch retrieve is being invoked on the choose address modal opening
	     */
	    directEditAddress : function(type, addressId, orderItemId, multiAddress) {
	      if (typeof(COSTCO.util) == 'undefined' || COSTCO.util.addresses.length == 0) {
	        COSTCO.util.getAddressBatchPage(type, 'FIRSTNAME', 'ASC', '96', function (data) {
	          CAddressForm.editAddress(type, addressId , orderItemId, multiAddress);
	        }); 
	       } else {
	    	 CAddressForm.editAddress(type, addressId, orderItemId, multiAddress);
	       }
	    },

	    createNewAddress : function(type,orderItemId,multiAddress){
	    	
	    	if (typeof addressOptions === 'undefined') {
	    		addressOptions = {};
	    	}
	    	if(typeof orderItemId !== 'undefined' && orderItemId > 0){
	    		addressOptions.orderItemId = orderItemId;
	    	}  	
	    	if (typeof addressOptions.url === 'undefined') {
	    		addressOptions.url = '/AjaxAddressAddCmd';
	    	}
	    	//need to add mode parameter if url is AjaxManageAddressCmd and doesn't have mode parameter already
	    	else if (addressOptions.url.indexOf('AjaxManageAddressCmd') > -1 && addressOptions.url.indexOf('mode') < 0) {
	    		addressOptions.url = COSTCO.util.makeUrl(addressOptions.url, {mode: 'ADD'});
	    	}
	    	//National delivery UX change to remove Terms and Condition Modal in Address book for BD US
			if ($('#isBDAppVar').val() == 'BD' && type == 'S' && !COSTCO.util.isNdEnabled()) {
				CAddressForm.showBusinessDeliveryQuestionnaireModal(type, undefined, 'add', addressOptions);
			} else {
				CAddressForm.openAddressAddModal(type, undefined, 'add', addressOptions);
			}
	    	

	    },

      createNewAddress_v2 : function(type,orderItemId,multiAddress){

        if (typeof addressOptions === 'undefined') {
          addressOptions = {};
        }
        if(typeof orderItemId !== 'undefined' && orderItemId > 0){
          addressOptions.orderItemId = orderItemId;
        }
        if (typeof addressOptions.url === 'undefined') {
          addressOptions.url = '/AjaxAddressAddCmd';
        }
        //need to add mode parameter if url is AjaxManageAddressCmd and doesn't have mode parameter already
        else if (addressOptions.url.indexOf('AjaxManageAddressCmd') > -1 && addressOptions.url.indexOf('mode') < 0) {
          addressOptions.url = COSTCO.util.makeUrl(addressOptions.url, {mode: 'ADD'});
        }

        if ($('#isBDAppVar').val() == 'BD' && type == 'S') {
          CAddressForm.showBusinessDeliveryQuestionnaireModal_v2(type, undefined, 'add', addressOptions);
        } else {
          CAddressForm.openAddressAddModal_v2(type, undefined, 'add', addressOptions);
        }
      },

	    createInline : function(selector, type, checkoutPage, multi){

	    	var html = COSTCO.CAddressForm.createHtml(type, undefined, 'add', 'inline', checkoutPage, multi);

	    	$(selector).html(html);

	        COSTCO.util.getAddressBatchPage(type, 'FIRSTNAME', 'ASC', '96', function(data) {

	        	if(data.totalRecords > 0){
	        		COSTCO.CAddressForm.createChooseLink(selector,type);
	        	}else{
	        		$(selector).find('#select-saved').addClass('hide');
	        	}

	        });

	    },
	    
	    createInline_v2 : function(selector, type, checkoutPage, multi, smsNotificationData){
	      var html;
	      if (typeof smsNotificationData !== 'undefined' ) {
	        html = COSTCO.CAddressForm.createHtml_v2(type, undefined, 'add', 'inline', checkoutPage, multi, null, smsNotificationData);
	      } else {
	        html = COSTCO.CAddressForm.createHtml_v2(type, undefined, 'add', 'inline', checkoutPage, multi);
	      }

	    	$(selector).html(html);

	        COSTCO.util.getAddressBatchPage(type, 'FIRSTNAME', 'ASC', '96', function(data) {

	        	if(data.totalRecords > 0){
	        		COSTCO.CAddressForm.createChooseLink(selector,type);
	        	}else{
	        		$(selector).find('#select-saved').addClass('hide');
	        	}

	        });
	        
	        let isPreventSameAddressEnabled = $('input[name="isPreventSameAddressEnabled"]');
            
            if(isPreventSameAddressEnabled.length > 0 && isPreventSameAddressEnabled.val()) {
		        $('body').unbind("costco.address.error").bind("costco.address.error", function(event, error) {
		      	  if(typeof(error) != 'undefined'){
		  				if(error == '_ERR_INVALID_SHIP_ADDR') {
		  					COSTCO.CAddress.closeModal();
		  					$('#notification-message').html(messages.ERR_SHIP_ADDR_SAME_AS_WHS_ADDR).addClass('critical-notification');
		  					let formId = $('#address-modal-inline');
		  		            let addressField = '#S_address1Id';
		  		            COSTCO.dialog.sameAddressValidation(formId, addressField);
		  				}
		  			}
		        });
            }

	    },

	    createChooseLink : function(selector, type){

	    	var chooseLink = "<a href=\"javascript:void(0)\" onclick=\"COSTCO.CAddressSelectionDialog.showAddressSelectionDialog(null,'{0}');return false;\">{1}</a>";

	    	var html = COSTCO.util.messageFormat(chooseLink, type, addressInputLabels.choosesaved);

	    	$(selector).find('#select-saved div').html(html);

	    },

	    insertSmsNotificationAgreement : function(orderId, orderSmsPhone) {
	    	
	    	let check = (orderSmsPhone.length > 0) ? 'checked' : '';
	    	if(orderSmsPhone.length == 10) {
	    		// Insert '-' to avoid onchange event fired on tab and other keys which don't change input field value. 
	    		let formatted = orderSmsPhone.substr(0, 3) + '-' + orderSmsPhone.substr(3, 3) + '-' + orderSmsPhone.substr(6,4)
	    		orderSmsPhone = formatted
	    	}
	    	let hide = (orderSmsPhone.length > 0) ? '' : 'hidden';
	    	let data = { 
	    			orderId : orderId,
	    			smsPhone : orderSmsPhone,
	    			check : check,
	    			hide : hide
	    			}
	    	var template = COSTCO.util.tmpl('tmpl_sms_notification_agreement_block',data);	
	    	$('.smsNotificationBlock').html(template);
	    },
	    
      insertSmsNotificationAgreement_v2 : function(arg, smsPhoneNumber, updateAction, checkCheckbox) {
        let check = (smsPhoneNumber.length > 0) ? 'checked' : '';
        if(smsPhoneNumber.length == 10) {
          // Insert '-' to avoid onchange event fired on tab and other keys which don't change input field value. 
          let formatted = smsPhoneNumber.substr(0, 3) + '-' + smsPhoneNumber.substr(3, 3) + '-' + orderSmsPhone.substr(6,4)
          smsPhoneNumber = formatted
        }
        let hide = (smsPhoneNumber.length > 0) ? '' : 'hidden';
        let data = {
          arg : arg,
          smsPhoneNumber : smsPhoneNumber,
          updateAction : updateAction,
          checkCheckbox : checkCheckbox,
          hide : hide
          }
        var template = COSTCO.util.tmpl('tmpl_sms_notification_agreement_block_v2',data);
        $('.smsNotificationBlock').html(template);
      },

	    createHtml : function(type, addressObj, mode, modaltypeOverride, checkoutPage, multi, error){

			var isDeriveCityStateEnabled = costcoStoreFeatures.DERIVE_CITY_STATE_FROM_ZIP_POSTAL_CODE_ENABLED
			&& $('input[name=deriveCityStateEnabled]') && $('input[name=deriveCityStateEnabled]').val() === "true";
	    	
	    	var stateProvList = address.getStateProvJson();
			COSTCO.CAddressForm.addressVal = stateProvList;
			var stateOptions = CAddressForm.getStateOptions(stateProvList,type,addressObj);
			var countryOptions = CAddressForm.getCountryOptions(type);

			var data = addressInputLabels;

			var headerLabels = address.getHeaderLabels(type, mode);

			data.primaryMessage = headerLabels.primaryMessage;
			var modaltype = 'modal';
			if(typeof(modaltypeOverride) !== 'undefined'){
				modaltype = modaltypeOverride;
			}
			
			var template = COSTCO.util.tmpl('tmpl_address_form_' + modaltype,data);
			template = $(template);
			
			if(!isDeriveCityStateEnabled){
				template.find('.stateprov-select').append(stateOptions);
			}
			
			template.find('.country-select').append(countryOptions).change(function(){

				var country = $(this).val();
				var stateOptions = CAddressForm.getStateOptions(stateProvList,type,{country:country});
				if(!isDeriveCityStateEnabled){
					template.find('.stateprov-select').empty().append(stateOptions);
				}
				updateCountryLabels(country);
				CAddressForm.maskInput(template);

			})

			if(typeof(error) != 'undefined'){
				if(error == '_ERR_INVALID_SHIP_ADDR') {
					template.append('<input type="hidden" name="invalid-ship-addr" value="true" />');				
				} else {
					template.find('.error').html(error);
				}
			}

			var updateCountryLabels = function(country){
				if(country == 'US'){
					template.find('label[for="postalId"]').html(data.uspostallabel);
					template.find('label[for="stateId"]').html(data.usstatelabel);
				}else{
					template.find('label[for="postalId"]').html(data.capostallabel);
					template.find('label[for="stateId"]').html(data.castatelabel);
				}
			}


			if(addressObj){
				updateCountryLabels(addressObj.country);
	    	}

			template.find('[name=postal]').on('input', {modaltype: modaltype}, function(event){
				var value = $(this).val();
				let region = COSTCO.util.isUsOrCaZipCode();
				if($('#isGeocodeService').val() != "true" && value != null && value != "" && value.trim().length > 4){
					COSTCO.CAddress.bingCityState(this,'[name=city]','[name=state]');
					if (checkoutPage == 'shipping' && event.data.modaltype == 'inline') {
						if($('#isBDAppVar').val() != 'BD'){
							COSTCO.ScheduledDeliverable.handleZipCodeChange(value);
						}
					}
				}
				if($('#isGeocodeService').val() === "true" && value != null && value != "" && value.trim().length === value.length){
					if (region && COSTCO.util.POSTAL_CODE_REGEX_US.test(value.trim())) {
						COSTCO.CAddress.geocodeApiCityState(this,'[name=city]','[name=state]');
					}
					if (!region) {
						if ((value.trim().length === 3 && /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1}/.test(value.trim())) || (value.trim().length === 7 && COSTCO.util.POSTAL_CODE_REGEX_CA.test(value.trim())))
						COSTCO.CAddress.geocodeApiCityState(this,'[name=city]','[name=state]');
					}
					if (checkoutPage == 'shipping' && event.data.modaltype == 'inline') {
						if($('#isBDAppVar').val() != 'BD'){
							COSTCO.ScheduledDeliverable.handleZipCodeChange(value);
						}
					}	
					
				}
			});
			
			if(type == 'B'){
				template.find('#country-row').removeClass('hide');
			}
			if(mode=='add'){
				template.find('[name=email]').val($('#defaultEmail').val());
			}
			if(type == 'S'){
				template.find('#delIntsr-row').removeClass('hide');
				template.find('#contactName').removeClass('ignoreHide');
				template.find('#contactPhNo').removeClass('ignoreHide');				
			}

			if(mode == 'edit'){
				template.find('.address-checkboxes').hide();
				if(addressObj.isPrimary == '1' && type == 'S') {
					template.find(".defaultWarning").removeClass('hide');
				} else {
					template.find(".defaultWarning").addClass('hide');
				}
			}

			/*
			 * Show the default shipping warning
			 */

			var updateWarning = function(modaltype){

				if(template.find('#set-default-' + modaltype).prop('checked')){
					template.find(".defaultWarning").removeClass('hide');
				}else{
					template.find(".defaultWarning").addClass('hide');
				}

			}
			
			if(mode == 'add') {
				if(type == 'S') {
					
					/* Below click binding function was added to the set-default checkbox to toggle setAsDefaultShippingAddress hidden field 
					 * on the page. This hidden field has to change based on the checkbox status so that page submit reads the right value to
					 * set on IsPrimary field of address record. */
					 template.find('#set-default-' + modaltype).bind( "click", function() {
						   if($('#set-default-' + modaltype).is(':checked')) {
							   $('#NewAddressSingleShippingForm input[name=setAsDefaultShippingAddress]').val('true');
						   } else {
							   $('#NewAddressSingleShippingForm input[name=setAsDefaultShippingAddress]').val('false');
						   }
					});
					
					template.find('#set-default-' + modaltype).click(function(){
						updateWarning(modaltype);
					})
				}
				
				let detectedCheckoutPage = (typeof checkoutPage !== 'undefined') ? checkoutPage : window.checkoutPage;
				
				if(detectedCheckoutPage === 'shipping' || detectedCheckoutPage === 'multi-shipping'  || detectedCheckoutPage === 'payment') {
					template.find('#set-default-' + modaltype).prop('checked',modaltype === 'inline'); 
				} else if( detectedCheckoutPage === 'review' || detectedCheckoutPage === 'live-tickets') {
					template.find('#set-default-' + modaltype).prop('checked', false);
				}
				updateWarning(modaltype);
			}
			
			template.find('#set-default-' + modaltype).click(function(){
				if($(this).prop('checked')){
					template.find('#save-address-' + modaltype).prop('checked',true);
				}
				if (checkoutPage == 'shipping') {
					updateWarning(modaltype);
				}
				
			})

			template.find('#save-address-' + modaltype).click(function(){
				if(!$(this).prop('checked')){
					$('#set-default-' + modaltype).prop('checked',false);
				}
				if (checkoutPage == 'shipping') {
					updateWarning(modaltype);
				}
			})

			if(typeof addressObj !== 'undefined'){
				CAddressForm.populateAddressModal(template, addressObj, modaltype)
			}else{
				template.find('[name=addressType]').val(type);
			}

			if ((checkoutPage === 'payment' || checkoutPage === 'review' || checkoutPage === 'live-tickets') && type == 'B' && modaltype == 'inline') {
				template.find('#address-same-as-ship').removeClass('hide');
			}
			
			if (type == 'B') {
				template.find(".defaultWarning").addClass('hide');
			}

			CAddressForm.maskInput(template);

	    	return template;

	    },
		// returns id of matching template element, or null
	    findTemplateId_v2: function(type, templateName, modalType){
	    	var result = null;
	    	modalType = (modalType == null || modalType == undefined || modalType == '') ? '' : ('_' + modalType);
	    	var template = $('#tmpl_' + type + '_' + templateName + modalType + '_v2');
	    	if(template.length == 0){ // look for template with the "_gift" suffix
				template = $('#tmpl_' + type + '_' + templateName + modalType + '_gift_v2');
			}
	    	if(template.length == 0){
	    		var orderItemInputs = $('input[name^="orderItem_"]');
	    		for(var i=0;i<orderItemInputs.length && template.length == 0;i++){
	    			var orderItemId = orderItemInputs.get(i).value;
	    			// look for template with the orderItemId
	    			template = $('#tmpl_' + type + '_' + templateName + modalType + ('_' + orderItemId) + '_v2');
	    			if(template.length == 0){ // look for template with the orderItemId and the "_gift" suffix
	    				template = $('#tmpl_' + type + '_' + templateName + modalType + ('_' + orderItemId) + '_gift_v2');
	    			}
	    		}
	    	}
			if(template.length == 1){
				result = template.attr('id');
			}
	    	return result;
	    },
	    
	    createHtml_v2 : function(type, addressObj, mode, modaltypeOverride, checkoutPage, multi, error, smsNotificationData){

	    	var stateProvList = address.getStateProvJson();
	    	
	    	var isDeriveCityStateEnabled = costcoStoreFeatures.DERIVE_CITY_STATE_FROM_ZIP_POSTAL_CODE_ENABLED
			&& $('input[name=deriveCityStateEnabled]') && $('input[name=deriveCityStateEnabled]').val() === "true";
	    	
	    	var stateOptions = CAddressForm.getStateOptions(stateProvList,type,addressObj);
			var countryOptions = CAddressForm.getCountryOptions(type);
			
			let addrType = (typeof(addressObj) == 'undefined') ? type : addressObj.addressType;

			var data = addressInputLabels;
			if (typeof smsNotificationData !== 'undefined' ) {
			  data.smsNotificationData = smsNotificationData;
			  data.showSMSNotificationCheckbox = true;
			} else {
			  data.smsNotificationData = {};
			  data.showSMSNotificationCheckbox = false;
			}
			var headerLabels = address.getHeaderLabels(type, mode);

			data.primaryMessage = headerLabels.primaryMessage;

			var modaltype = 'modal';
			if(typeof(modaltypeOverride) !== 'undefined'){
				modaltype = modaltypeOverride;
			}
			
			var templateId = CAddressForm.findTemplateId_v2(type, 'address_form', modaltype);
			var template = COSTCO.util.tmpl(templateId, data);

			template = $(template);
			if (!data.showSMSNotificationCheckbox) {
			  template.find('#smsNotificationCheckBox').remove();
			}
			
			if(!isDeriveCityStateEnabled){
				template.find('.stateprov-select').append(stateOptions);
			}
			
			template.find('.country-select').append(countryOptions).change(function(){

				var country = $(this).val();
				var stateOptions = CAddressForm.getStateOptions(stateProvList,type,{country:country});
				if(!isDeriveCityStateEnabled){
					template.find('.stateprov-select').empty().append(stateOptions);
				}
				template.find('#city-state').addClass('hide');
				template.find('input[id='+addrType+'_postalId]').val('');
				template.find('label[for='+addrType+'_postalId]').removeClass('active');
				updateCountryLabels(country);
				CAddressForm.maskInput(template);

			})

			if(typeof(error) != 'undefined'){
				if(error == '_ERR_INVALID_SHIP_ADDR') {
					template.append('<input type="hidden" name="invalid-ship-addr" value="true" />');
					template.find('.error').html(messages.ERR_SHIP_ADDR_SAME_AS_WHS_ADDR).addClass('critical-notification cds-u-space-mb-md');
					
				} else {
					template.find('.error').html(error);
				}
			}

			var updateCountryLabels = function(country){
				if(country == 'US'){
					template.find('label[for="'+addrType+'_postalId"]').html(data.uspostallabel);
					template.find('label[for="'+addrType+'_stateId"]').html(data.usstatelabel);
					template.find('label[id="zip-info-text"]').html(data.usZipInfoText);
				}else{
					template.find('label[for="'+addrType+'_postalId"]').html(data.capostallabel);
					template.find('label[for="'+addrType+'_stateId"]').html(data.castatelabel);
					template.find('label[id="zip-info-text"]').html(data.caZipInfoText);
				}
			}


			if(addressObj){
				updateCountryLabels(addressObj.country);
	    	}

			template.find('[name=postal]').on('input', {modaltype: modaltype}, function(event){
				var value = $(this).val();
				let region = COSTCO.util.isUsOrCaZipCode();
				if($('#isGeocodeService').val() != "true" && value != null && value != "" && value.trim().length > 4){
					COSTCO.CAddress.bingCityState(this,'[name=city]','[name=state]');
					if (checkoutPage == 'shipping' && event.data.modaltype == 'inline') {
						if($('#isBDAppVar').val() != 'BD'){
							COSTCO.ScheduledDeliverable.handleZipCodeChange(value);
						}
					}
				}
				if($('#isGeocodeService').val() === "true" && value != null && value != "" && value.trim().length === value.length){
					if (region && COSTCO.util.POSTAL_CODE_REGEX_US.test(value.trim())) {
						COSTCO.CAddress.geocodeApiCityState(this,'[name=city]','[name=state]');
					}
					if (!region) {
						if ((value.trim().length === 3 && /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1}/.test(value.trim())) || (value.trim().length === 7 && COSTCO.util.POSTAL_CODE_REGEX_CA.test(value.trim()))) {
						COSTCO.CAddress.geocodeApiCityState(this,'[name=city]','[name=state]');
						}
					}
					if (checkoutPage == 'shipping' && event.data.modaltype == 'inline') {
						if($('#isBDAppVar').val() != 'BD'){
							COSTCO.ScheduledDeliverable.handleZipCodeChange(value);
						}
					}	
					
				}
			});
			if(type == 'B'){
				template.find('#country-row').removeClass('hide');
			}
			if(mode=='add'){
				template.find('[name=email]').val($('#defaultEmail').val());
			}
			if(type == 'S'){
				template.find('#delIntsr-row').removeClass('hide');
				template.find('#contactName').removeClass('ignoreHide');
				template.find('#contactPhNo').removeClass('ignoreHide');
				$('#contact-information-phone').css('padding-left', '0');
			}

			if(mode == 'edit'){
				if (addressObj.addressType !== 'T') {
					template.find('#save-to-address-book').hide();
				}
				if (addressObj.isPrimary == '1') {
					template.find('#set-default-address').hide();
				}
				if(addressObj.isPrimary == '1' && type === 'S') {
					template.find(".defaultWarning").show();
				} else {
					template.find(".defaultWarning").hide();
				}
				if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE === true) {
					if (template.find('#save-to-address-book').is(':hidden') === true && template.find('#set-default-address').is(':hidden') === true) {
						template.find('.checkbox-separator').addClass('hide');
					}
				}
			}

			/*
			 * Show the default shipping warning
			 */

			var updateWarning = function(modaltype){

				if(template.find('#set-default-' + modaltype).prop('checked')){
					template.find(".defaultWarning").removeClass('hide');
				}else{
					template.find(".defaultWarning").addClass('hide');
				}

			}
			
			if(mode == 'add') {
				if(type == 'S') {
					
					/* Below click binding function was added to the set-default checkbox to toggle setAsDefaultShippingAddress hidden field 
					 * on the page. This hidden field has to change based on the checkbox status so that page submit reads the right value to
					 * set on IsPrimary field of address record. */
					 template.find('#set-default-' + modaltype).bind( "click", function() {
						   if($('#set-default-' + modaltype).is(':checked')) {
							   $('#NewAddressSingleShippingForm input[name=setAsDefaultShippingAddress]').val('true');
						   } else {
							   $('#NewAddressSingleShippingForm input[name=setAsDefaultShippingAddress]').val('false');
						   }
					});
					
					template.find('#set-default-' + modaltype).click(function(){
						updateWarning(modaltype);
					})
				}
				
				let detectedCheckoutPage = (typeof checkoutPage !== 'undefined') ? checkoutPage : window.checkoutPage;
				
				if (detectedCheckoutPage === 'multi-shipping') {
					template.find('#set-default-' + modaltype).prop('checked',modaltype === 'inline'); 

				} else if(detectedCheckoutPage === 'review') {
					template.find('#set-default-' + modaltype).prop('checked', false);
				}
				updateWarning(modaltype);
			}
			
			template.find('#set-default-' + modaltype).click(function(){
				if($(this).prop('checked')){
					template.find('#save-address-' + modaltype).prop('checked',true);
					$('#set-default-' + modaltype).prop('value',true);
					$('.defaultWarning.kb-OOS-banner').show();
				} else {
					$('#set-default-' + modaltype).prop('value',false);
					$('.defaultWarning.kb-OOS-banner').hide();
				}
			})

			template.find('#save-address-' + modaltype).click(function(){
				if(!$(this).prop('checked')){
					$('#set-default-' + modaltype).prop('checked',false);
					$('.defaultWarning.kb-OOS-banner').hide();
				}
				if (checkoutPage == 'shipping') {
					updateWarning(modaltype);
				}
			})

			if(typeof addressObj !== 'undefined'){
				CAddressForm.populateAddressModal_v2(template, addressObj, modaltype)
			}else{
				template.find('[name=addressType]').val(type);
			}

			if (type === 'B' && modaltype === 'inline') {				
				template.find('#address-same-as-ship').removeClass('hide');
			}
			
			if (type == 'B') {
				template.find(".defaultWarning").addClass('hide');
			}

			CAddressForm.maskInput(template);

			//SFSTRY0015679 make company name mandatory in USBD for Local Business Delivery
			let isLocalBusinessDelivery = typeof shipModeLocalND !== 'undefined' && ($("input[name='deliveryMethod']:checked").val() == shipModeLocalND || $("input[name='deliveryMethod']:checked").val() == shipModeLocal);
			if ($('#isBDAppVar').val() === 'BD'){
				//SFSTRY0020930 - check if xapp flag for company name mandate is enabled
				let isCompanyMandateEnabled = $("#isCompanyMandateEnabled").val();
				if(wcs.storeId === '11303' || wcs.storeId === '11301' && isLocalBusinessDelivery && isCompanyMandateEnabled === "true") {
					$(template).find('[name=company]').parent().parent().removeClass('hide');
					$(template).find('#showCompanyField').parent().addClass('hide');
				}
	        }
			
	    	return template;

	},

	    populateAddressModal : function (template, addressObject, modaltype){

			template.find('[name=addressId]').val(addressObject['id']);
			template.find('#firstId').val(addressObject['first']);
			template.find('#lastId').val(addressObject['last']);
			var companyName = COSTCO.util.get_decoded_html(addressObject['company']);
			if(companyName != undefined && companyName != "undefined" && companyName != ""){
				template.find('#companyId').val(companyName);
			}else{
				template.find('#companyId').val("");
			}
			template.find('[name=country]').val(addressObject['country']);
			template.find('[name=address1]').val(addressObject['line1']);
			template.find('[name=address2]').val(addressObject['line2']);
			template.find('[name=postal]').val(addressObject['zip']);
			
			if(costcoStoreFeatures.DERIVE_CITY_STATE_FROM_ZIP_POSTAL_CODE_ENABLED 
					&& $('input[name=deriveCityStateEnabled]') && $('input[name=deriveCityStateEnabled]').val() === "true"){
				var editAddrCity = addressObject['city'];
				var editAddrState = addressObject['state'];
				var postalField = template.find('[name=postal]');
				COSTCO.CAddress.geocodeApiCityState(postalField,'[name=city]','[name=state]', editAddrCity, editAddrState);
			} else {
				template.find('[name=city]').val(addressObject['city']);
				template.find('[name=state]').val(addressObject['state']);
				template.find('#city-state').removeClass('hide');
			}
			
			if(addressObject['phone']!= undefined && addressObject['phone'] != ""){
				if($('#isBDAppVar').val() == 'BD'){
					template.find('#phoneId').val(addressObject['phone'].split(/EXT.|x/g)[0]);
					var extension = addressObject['phone'].split(/EXT.|x/g)[1];
					if (extension){
						template.find('[name=ext1]').val(extension.trim());
					}
				}else{
					template.find('#phoneId').val(addressObject['phone'].split('x')[0]);
					template.find('[name=ext1]').val(addressObject['phone'].split('x')[1]);
				}
			}else{
				template.find('#phoneId').val(addressObject['phone']);
				template.find('[name=ext1]').val(addressObject['phone']);
			}
			template.find('[name=nickname]').val(addressObject['nickname']);
			template.find('[name=email]').val(addressObject['email']);
	    	template.find('[name=addressType]').val(addressObject.addressType);
	    	template.find('[name=addressId]').val(addressObject.id);
	    	if(addressObject['deliveryInstructions']){
	    		var deliveryInst = COSTCO.util.get_decoded_html(addressObject['deliveryInstructions']);
	    	}else if(addressObject['deliveryInst']){
	    		var deliveryInst = COSTCO.util.get_decoded_html(addressObject['deliveryInst']);
	    	}
	    	template.find('[name=deliveryInstructions]').val(deliveryInst);
	    	template.find('[name=contactName]').val(addressObject['contactName']);
	    	template.find('[name=contactPhone]').val(addressObject['contactPhNo']);

	    	if(addressObject.addressType != 'T'){
	    		template.find('#save-address-' + modaltype).prop('checked', true);
	    	}

	    	if(addressObject.isPrimary == '1'){
	    		template.find('#set-default-' + modaltype).prop('checked', true);
	    	}

	    	if(addressObject.isPrimary === '1' && addressObject.addressType === 'S' && (typeof(checkoutPage) !== 'undefined' && checkoutPage === 'shipping')){
	    		template.find('.defaultWarning').removeClass('hide');
	    	}
			$(template).find('#phoneId').unmask().mask('000-000-0000');
	    },

	    populateAddressModal_v2 : function (template, addressObject, modaltype){

			template.find('[name=addressId]').val(addressObject['id']);
			
			template.find('[name=firstModal]').val(addressObject['first']);
			template.find('label[for="'+addressObject.addressType+'_firstId"]').addClass('active');
			
			template.find('[name=lastModal]').val(addressObject['last']);
			template.find('label[for="'+addressObject.addressType+'_lastId"]').addClass('active');
			
			var companyName = COSTCO.util.get_decoded_html(addressObject['company']);
			if(companyName !== undefined && companyName !== "undefined" && companyName !== ""){
				template.find('#'+addressObject.addressType+'_companyId').val(companyName);
				template.find('label[for="'+addressObject.addressType+'_companyId"]').addClass('active');
				COSTCO.CAddressForm.showInputFiled(template.find('#showCompanyField'));
			} else {
				template.find('#'+addressObject.addressType+'_companyId').val('');
			}
			template.find('[name=country]').val(addressObject['country']);
			template.find('label[for="'+addressObject.addressType+'_countryId"]').addClass('active');
			
			template.find('[name=address1]').val(addressObject['line1']);
			template.find('label[for="'+addressObject.addressType+'_address1Id"]').addClass('active');
			
			if(addressObject['line2'] !== undefined && addressObject['line2'] !== "undefined" && addressObject['line2'] !== "") {
				template.find('[name=address2]').val(addressObject['line2']);
				template.find('label[for="'+addressObject.addressType+'_address2Id"]').addClass('active');
				COSTCO.CAddressForm.showInputFiled(template.find('#showAptField'));
			} else {
				template.find('[name=address2]').val('');
			}
			
			template.find('[name=postal]').val(addressObject['zip']);
			template.find('label[for="'+addressObject.addressType+'_postalId"]').addClass('active');
			
			if(costcoStoreFeatures.DERIVE_CITY_STATE_FROM_ZIP_POSTAL_CODE_ENABLED 
					&& $('input[name=deriveCityStateEnabled]') && $('input[name=deriveCityStateEnabled]').val() === "true"){
				var editAddrCity = addressObject['city'];
				var editAddrState = addressObject['state'];
				var postalField = template.find('[name=postal]');
				COSTCO.CAddress.geocodeApiCityState(postalField,'[name=city]','[name=state]', editAddrCity, editAddrState);
			} else {
				template.find('[name=city]').val(addressObject['city']);
				template.find('[name=state]').val(addressObject['state']);
			}
			
			template.find('label[for="'+addressObject.addressType+'_cityId"]').addClass('active');
			template.find('label[for="'+addressObject.addressType+'_stateId"]').addClass('active');
			
			template.find('#city-state').removeClass('hide');
			
			if(addressObject['phone']!= undefined && addressObject['phone'] != ""){
				if ($('#isBDAppVar').val() == 'BD') {
					template.find('[name=phone]').val(addressObject['phone'].split(/EXT.|x/g)[0]);
					template.find('label[for="'+addressObject.addressType+'_phoneId"]').addClass('active');
					var extension = addressObject['phone'].split(/EXT.|x/g)[1];
					if (extension) {
						template.find('[name=ext1]').val(extension.trim());
						template.find('label[for="ext1"]').addClass('active');
					}
				} else {
					template.find('[name=phone]').val(addressObject['phone'].split('x')[0]);
					template.find('label[for="'+addressObject.addressType+'_phoneId"]').addClass('active');
					template.find('[name=ext1]').val(addressObject['phone'].split('x')[1]);
				}
			}else{
				template.find('[name=phone]').val(addressObject['phone']);
				template.find('[name=ext1]').val(addressObject['phone']);
			}
			template.find('[name=nickname]').val(addressObject['nickname']);
			
			template.find('[name=email]').val(addressObject['email']);
			template.find('label[for="'+addressObject.addressType+'_emailId"]').addClass('active');
			
			template.find('[name=addressType]').val(addressObject.addressType);
			template.find('[name=addressId]').val(addressObject.id);
			template.find('[name=deliveryInstructions]').val(addressObject['deliveryInstructions']);
			if (addressObject['deliveryInstructions'] != undefined && addressObject['deliveryInstructions'].length > 0) {
				template.find('label[for=deliveryInstructions-modal]').addClass('active');
			}
			template.find('[name=contactName]').val(addressObject['contactName']);
			if (addressObject['contactName'] != undefined && addressObject['contactName'].length > 0) {
				template.find('label[for=contactName]').addClass('active');
			}
			template.find('[name=contactPhone]').val(addressObject['contactPhNo']);
			if (addressObject['contactPhNo'] != undefined && addressObject['contactPhNo'].length > 0) {
				template.find('label[for=contactPhNo]').addClass('active');
			}

			if(addressObject.addressType != 'T'){
				template.find('#save-address-' + modaltype).prop('checked', true);
			}

			if(addressObject.isPrimary == '1'){
				template.find('#set-default-' + modaltype).prop('checked', true);
			}

			if(addressObject.isPrimary === '1' && addressObject.addressType === 'S' && (typeof(checkoutPage) !== 'undefined' && checkoutPage === 'shipping')){
				template.find('.defaultWarning').removeClass('hide');
			}

			if(addressObject === '') {
				COSTCO.CAddressForm.restoreLabelsAndHiddenFieldsForEmptyAddressObject(template);
			}
			template.find('#'+addressObject.addressType+'_phoneId').unmask().mask('000-000-0000');
			
			if(template.find('#phoneId').length > 0) {
				$(template).find('#phoneId').unmask().mask('000-000-0000');
			}
		},

	    restoreLabelsAndHiddenFieldsForEmptyAddressObject: function(template) {
	    	template.find('#city-state').addClass('hide');
    		template.find('label').each(function() {
    			if($(this).hasClass("active")) {
    				$(this).removeClass("active");
    			}
    		});
    		COSTCO.CAddressForm.hideInputFiled(template.find('#showAptField'));
    		COSTCO.CAddressForm.hideInputFiled(template.find('#showCompanyField'));
	    },
	    
	    /**
	     * function that populates address form with given address
	     * @param input
	     * 			input address form that needs to be populated
	     * @param addressId
	     * 			address that will be populated in address form
	     * @param modaltype
	     * 			param that determines if form is modal or inline
	     */
		populateAddressFormWithAddressData : function (input, addressId, modaltype) {
			
			let data = '';
			if (input.checked && addressId !== '') {
				data = window['ajaxAddressObject_' + addressId];
				delete data['id'];
				delete data['nickname'];
				if(costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE === false) {
					data.isPrimary = '1';
				}
			}
			
			if(costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE === true) {
				// Add right prefix for address form input ids
				data.addressType = $(input).get(0).name === "same-as-billing" ?  'S' : 'B';
				CAddressForm.populateAddressModal_v2($(input.form), data, modaltype);
			} else {
				CAddressForm.populateAddressModal($(input.form), data, modaltype);
			}
		},
	    addressNotServicedModal: function(verifiedAddress, cancelFn, submitFn, message) {	    	
	    	// Workaround for undefined verifiedAddress 
	    	let addressObject = {
	    			addressNotServicedMsg1: messages.ERR_MODAL_ADDRESS_NOT_SERVICED,
	    			firstName: '',
    				lastName: '',
    				address1: '',
    				city: '',
    				state: '',
    				zip: '',
	    			addressNotServicedMsg2: messages.MODAL_ADDRESS_NOT_SERVICED
	    			};	    	
	    	if (typeof(verifiedAddress) !== 'undefined') {
	    		addressObject = {
	    				addressNotServicedMsg1: messages.ERR_MODAL_ADDRESS_NOT_SERVICED,
	    				firstName: verifiedAddress.first,
	    				lastName: verifiedAddress.last,
	    				address1: verifiedAddress.line1,
	    				city: verifiedAddress.city,
	    				state: verifiedAddress.state,
	    				zip:verifiedAddress.zip,
	    				addressNotServicedMsg2: messages.MODAL_ADDRESS_NOT_SERVICED
	    				}
	    	}			
	    	if(COSTCO.util.isNdEnabled()){
	    		let modalAddressNotServicedForResidentialMessage =
	    			(costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE === true) ? messages.MODAL_ADDRESS_NOT_SERVICED_FOR_RESIDENTIAL_v2 : messages.MODAL_ADDRESS_NOT_SERVICED_FOR_RESIDENTIAL;
	    		if(message!=null && message=="residentialNotServiced"){
	    			addressObject.addressNotServicedMsg1= messages.ERR_MODAL_ADDRESS_NOT_SERVICED_FOR_RESIDENTIAL;
		    		addressObject.addressNotServicedMsg2= modalAddressNotServicedForResidentialMessage;
	    		}else{
	    			addressObject.addressNotServicedMsg1= messages.ERR_MODAL_ADDRESS_NOT_SERVICED_CART_MERGE;
		    		addressObject.addressNotServicedMsg2= messages.MODAL_ADDRESS_NOT_SERVICED_CART_MERGE;
	    		}
	    		addressObject.address2 = verifiedAddress.line2; 
	    	}
	    	var template = COSTCO.util.tmpl('tmpl_address_not_serviced_modal', addressObject);
				address.baseModal('S','addrnotserviced',{
					title: messages.MODAL_ADDRESS_NOT_SERVICED_TITLE,
					body: template,
					primary: messages.ADDRESS_NOT_SERVICED_SHOP,
					secondary: messages.JS_DIALOG_CANCEL,
					primary_event: function(){
						if (submitFn) {submitFn();}
						else {COSTCO.dialog.close();}
					},
					secondary_event: function(){
						if (cancelFn) {cancelFn();}
						else {COSTCO.dialog.close();}					
					}
		    	});
			
		},

	    openAddressAddModal : function(type, addressObj, mode, addressOptions) {	
	    	var openAddress = function(error){
	    		let htmlBody = CAddressForm.createHtml(type, addressObj, mode, undefined, undefined, undefined, error);
	    		// if it is edit mode, trigger jQuery validation immediately
	    		if(mode == "edit") {
	    			CAddressForm.validate(type, htmlBody);
	    		}
	    		var validateAddressTypeModal=[];
	    		if(addressObj!=undefined){
	    			validateAddressTypeModal[0] = addressObj.line1;
	    			validateAddressTypeModal[1] = addressObj.zip;
	    			validateAddressTypeModal[2] = addressObj.city;
	    			if(addressObj.userAddressType!='U'){
	    				validateAddressTypeModal[3] = addressObj.userAddressType;
	    			}
	    		}
	    		addressOptions.validateParams=validateAddressTypeModal;
	    		address.baseModal(type,mode,{
	    			body : htmlBody,
		    		primary_event : function(){
			    		if (CAddressForm.validate(type)){
			    			var addressEnteredForCheck = $('#addressEnteredForCheck');
			    			var address1 = $('FORM[id="address-modal-modal"]').find("#address1Id").val();
			    			if(!addressEnteredForCheck.length){
			    				addressEnteredForCheck = $('<INPUT TYPE="hidden" ID="addressEnteredForCheck" />').appendTo(document.body);
			    			}
			    			addressEnteredForCheck.val(address1);
			    			CAddressForm.submit(type, false, addressOptions);
			    		}

		    		},
		    		onshown: function(){
		    			if(addressOptions.setAsDefaultAddress){
		    				$('#set-default').val('true').attr('checked', true);
		    			} else {
		    				$('#set-default').val('false').attr('checked', false);
		    			}
		    			var invalidShipAddr = $('input[name=invalid-ship-addr]');
		    			if(invalidShipAddr.length > 0 && invalidShipAddr.val() === 'true') {
		    				var formId = $('#address-modal-modal');
		    				var addressField = '#address1Id';
		    				COSTCO.dialog.sameAddressValidation(formId, addressField);
		    			}
		    		}
		    	});
	    	}
	    	openAddress(undefined);

	        $('body').unbind("costco.address.error").bind("costco.address.error", function(event, error) {
	        	openAddress(error);
	        });


	    },

	    openAddressAddModal_v2 : function(type, addressObj, mode, addressOptions) {
        var openAddress = function(error){
          let htmlBody = CAddressForm.createHtml_v2(type, addressObj, mode, undefined, undefined, undefined, error);
          if(mode == "edit") {
  			CAddressForm.validate(type, htmlBody);
  		  }
          address.baseModal(type,mode,{
            body : htmlBody,
            primary_event : function(){

              if (CAddressForm.validate(type)){
                CAddressForm.submit(type, false, addressOptions);
              }

            },
            onshown: function(){
            	 if($('input[name=invalid-ship-addr]').length > 0 && $('input[name=invalid-ship-addr]').val() === 'true') {
	            	let formId = $('#address-modal-modal');
	                let addressField = '#S_address1Id';
	                COSTCO.dialog.sameAddressValidation(formId, addressField);
            	 }
            }
          });
        }
        openAddress(undefined);

        $('body').unbind("costco.address.error").bind("costco.address.error", function(event, error) {
          openAddress(error);
        });
      },

	    /**This function checks if the address line has reached max length, and if that is the case shows friendly message
	     * 
	     * Param 
	     * data:	data from children's element 
	     */
	    validateAddressLineLength : function(data){
			   let maxLength = 30;
			   let errorElement = document.getElementById("address-error-message-"+data.id);
			   if (data.value.length === maxLength) {
				   //check if errorElement has error class
				   if($(errorElement).hasClass("hide")) {
					   $(errorElement).removeClass("hide");
				   }
			   } else {
				   $(errorElement).addClass("hide");
			   }
		},
	    submit : function(type, preventHtmlReload, addressOptions){
	    	let addressArray = CAddressForm.buildAddressArray(type);

	    	if (typeof addressOptions === 'undefined') {
	    		addressOptions = {};
	    	}
	    	if($('#isBDAppVar').val() == 'BD' && type=='S'){
	    		let page = $('div#address').data('page') || '';
	    		
	    		if(!COSTCO.CAddressForm.isFormCompleted('S')&& !(page === 'Home,MyAccount,AccountAddressBook') && !COSTCO.util.isNdEnabled()){
	    			CAddressForm.showBDQuestionnaireModalForInlineForm(type,preventHtmlReload,addressOptions,addressArray);
	    		}else{
	    			addressOptions.successCallback = CAddressForm.addressVerifiedCallback;
	    			addressVerification.addressVerification(addressArray, type, preventHtmlReload, addressOptions);
	    		}
	    	}else{
	    		// BEGIN
		    	// NOTE: Below code is introduced with following commit/fix:
		    	// Grocery- Defect Fix 9968 Change-Id: Ifdb9bcbc501a5abc9c95733eeffe5140cd7ac55b
		    	//
		    	// We probably do not need it any more.
		    	// If encountering issues, please contact developer
		    	// 
		    	// if(typeof orderItemId != 'undefined'){
			    // 	if(typeof(orderItemId) == 'number'){
				    	
			    // 		addressOptions.orderItemId=orderItemId;
			    // 	}
			    // 	else{
				   //  	addressOptions.orderItemId=orderItemId.orderItemId;
		
			    // 	}
		    	// }
		    	// else{
		    	// 	addressOptions.orderItemId='';
		    	// }
		    	// END
		    	addressOptions.successCallback = CAddressForm.addressVerifiedCallback;
	
		    	addressVerification.addressVerification(addressArray, type, preventHtmlReload, addressOptions);
	    	}
	    },
	    /**
	     * Callback function for address form, on completed address verification service call
	     * @param {}
	     */
	    addressVerifiedCallback : function(addressObj, type, preventajaxhtml, addressOptions) {
					    	
	    	if (typeof addressObj !== 'undefined' && addressObj != null && addressObj.Validated_Address != undefined && addressObj.Validated_Address != null) {				
					if (addressObj.errorMessage != null && addressObj.errorMessage.length > 0) {
						$('.address-text-error').text(addressObj.errorMessage);
					}
					else if (addressObj.Validated_Address[0].result == 'ADDRESS_SUGGESTION_AVAILABLE' ||
						addressObj.Validated_Address[0].result == 'ADDRESS_WRONG_NO_SUGGESTION' ||
						addressObj.Validated_Address[0].result == 'ADDRESS_CORRECT_NO_SUGGESTION') {
						let additionalBillingStates = CAddressForm.getAdditionalBillingStates();
						if (addressObj.Validated_Address[0].result == 'ADDRESS_SUGGESTION_AVAILABLE'
								&& additionalBillingStates.includes(addressObj.Validated_Address[0].state)
								&& type == 'S') {
							// SFSTRY0038578: Do not suggest address from unsupported territories for shipping address
							addressObj.Validated_Address[0].result = 'ADDRESS_WRONG_NO_SUGGESTION';
						}
						if (addressVerification.isSuggestedSameAsEntered(addressObj)) {
							var validatedAddress = addressVerification.extractValidatedAddress(addressObj, type);
							COSTCO.CAddressVerification.entered = validatedAddress;
							addressVerification.useAddress(preventajaxhtml, addressOptions);
							//address.addEditAddress(validatedAddress, preventajaxhtml, addressOptions);
						}  else{
							addressVerification.showAddressVerificationModal(addressObj, preventajaxhtml, addressOptions);
						}
					} else if(addressObj.Validated_Address[0].result == 'ADDRESS_SERVICE_UNAVAILABLE') {
						var validatedAddress = addressObj.Validated_Address[0];
						address.addEditAddress(validatedAddress, preventajaxhtml, addressOptions);
					} else {
						var validatedAddress = addressVerification.extractValidatedAddress(addressObj, type);
						address.addEditAddress(validatedAddress, preventajaxhtml, addressOptions);
					}
				}else {
					if (addressObj.errorMessageParam != null && addressObj.errorMessageParam.length > 0){
						elementObj = $('[name='+addressObj.errorMessageParam[0]+']');
						
						if (elementObj.length > 0 ) {
								
								elementObj.parent().addClass('error');
								elementObj.attr('hasvalidationerror', true);
								elementObj.attr('firstNameValidation', true);
								elementObj.attr('lastNameValidation', true);
								COSTCO.CAddressForm.getForm().valid();
								
					    }
					}	
					else if (addressObj.errorMessage != null && addressObj.errorMessage.length > 0) {
						if ($('#address-modal-inline').length > 0){
							COSTCO.CAddress.closeModal();
						}
						$('.address-text-error').text(addressObj.errorMessage);	
					}
				}
			},
			
		getAdditionalBillingStates : function (){
			const states = [];
			const territories = $('#additional_Billling_Territories').val()
			if (territories !== null && territories !== undefined && territories !== "") {
				const codeAndDisplayNameOfTerritories = territories.split('|');
				if(codeAndDisplayNameOfTerritories.length !== 0) {
					$.each(codeAndDisplayNameOfTerritories, function(index, codeAndDisplayName) {
						const code = codeAndDisplayName.split(':')[0];
						if (code !== null && code !== undefined && code !== "") {
							const displayName = codeAndDisplayName.split(':')[1];
							if (displayName !== null && displayName !== undefined && displayName !== "") {
								const state = {code: code, displayName: displayName};
								states.push(state);
							}
						}
					});
					return states.map(state => state.code);
				}
			}
			return states;
		},

		getStateOptions : function(stateProvList,type, address) {
			let locale = 'en-US';
				locale = COSTCO.util.getLocale();

			let defaultCountry = locale.split('-')[1];
			const additionalBillingStatesCode = CAddressForm.getAdditionalBillingStates();
			
			$('#state').on('change', function() {
				CAddressForm.hideCheckboxForAdditionalTerritories(this.value, additionalBillingStatesCode)
			});
			
			if(type == 'S'){
				let states = CAddressForm.getStates(stateProvList, defaultCountry);
				const filterOutStates = [...additionalBillingStatesCode, 'VI'];
				let filteredStates = states.filter(function(state) {
		            return  !filterOutStates.includes(state.code);
				});
				return CAddressForm.getStateProvDropDown(filteredStates);
			} else{
				var states = '';
				if(typeof(address) !== 'undefined' && typeof(address.country )!== 'undefined'){
					states = CAddressForm.getStates(stateProvList, address.country);
				}else{
					states = CAddressForm.getStates(stateProvList, defaultCountry);
				}
				if(wcs.isPharmacy === "true") {
					let filteredStates = states.filter(function(state) {
			            return  !additionalBillingStatesCode.includes(state.code);
					});
					return CAddressForm.getStateProvDropDown(filteredStates);
				}
				return CAddressForm.getStateProvDropDown(states);
			}

			return '';

		}, 
		hideCheckboxForAdditionalTerritories : function(enteredCode,additionalBilllingStatesCodes) {
			if(additionalBilllingStatesCodes !== null && additionalBilllingStatesCodes !== undefined) {
				if (additionalBilllingStatesCodes.length !== 0) {
					if ($.inArray(enteredCode, additionalBilllingStatesCodes) !== -1) {
						$('#set-default').prop('checked', false);
						$('.save-address-in-book').prop('checked', false);
						$('.defaultWarning').addClass('hide');
						$('#default-address-checkbox').addClass('hide');
						$("#add-to-address-book-checkbox").addClass('hide');
					} else {
						$('.save-address-in-book').prop('checked', true);
						$('#default-address-checkbox').removeClass('hide');
						$('#add-to-address-book-checkbox').removeClass('hide');
					}
				}
			}
		},

		getCountryOptions : function(type) {

			if(type == 'S'){
				return CAddressForm.getCountryDropDown(shippingCountries);
			}else{
				return CAddressForm.getCountryDropDown(billingCountries);
			}

			return '';

		},

		getStates : function (stateProvList, country){

			for(var i=0;i<stateProvList.length;i++){
			    var stateProvCountry = stateProvList[i].code;
			    if(stateProvCountry == country){
			    	return stateProvList[i].states;
			    }
			}

		},

		getStateProvDropDown : function(states){

			html = '';
			for(var i=0;i<states.length;i++){
				html += '<option value="' + states[i].code + '">' + states[i].displayName + '</option>';
			}
			return html;

		},
		
		getCityDropDown : function(cities){

			html = '';
			for(var i=0;i<cities.length;i++){
				html += '<option value="' + cities[i] +'">' + cities[i] + '</option>';
			}
			return html;

		},

		getCountryDropDown : function(countriesList){

			html = '';

			var langId = COSTCO.util.getLangId();
			if(langId == -1){
				countries.sort(function(a,b){return a.code < b.code ? 1 : -1})
			}

			for(var k=0; k < countries.length; k++) {

				if(countriesList.indexOf(countries[k].code) >= 0){
					html += '<option value="' + countries[k].code + '">' + countries[k].displayName + '</option>';
				}

			}
			return html;

		},

		getForm : function(){

			var forms = $('.address-form');

			if(forms.length > 1){
				return $('#address-modal-modal');
			}else{
				return forms;
			}

		},

		validate : function(type, formToValidate, isEditDefaultShippingAddress) {

			CAddressForm.validationRules();
			
			function getAddressLine1MaxCharLength(){
				let addressLine1MaxChar = 30;
				if($('#isBDAppVar').val() == 'BD'){
					addressLine1MaxChar = 35;
				}
				return addressLine1MaxChar;
			}
					
			function getFirstLastNameRule(){
				let firstLastNameMaxChar = 40;
				let firstLastNameRule = {
					required: true
				}
				if ($('#isBDAppVar').val() == 'BD') {
					firstLastNameRule.maxlength = firstLastNameMaxChar;
				}
				return firstLastNameRule.required;
			}
			
			function isCompanyRequired(){
				if ($('#isBDAppVar').val() == 'BD') {
					//SFSTRY0020930 - check if xapp flag for company name mandate is enabled
					let isCompanyMandateEnabled = $("#isCompanyMandateEnabled").val();
					let isLocalDelivery = typeof shipModeLocalND !== 'undefined' && ($("input[name='deliveryMethod']:checked").val() == shipModeLocalND || $("input[name='deliveryMethod']:checked").val() == shipModeLocal);
					let modalTitle = $('#costcoModalTitle').text();
					window.digitalDataEvents = window.digitalDataEvents || [];	
					if(type == 'S'){
						//SFSTRY0015679 - Company name mandated for Local business delivery.
						if (shippingCountries[0] == "US"){																		
							if(isCompanyMandateEnabled === "true" && isLocalDelivery){
								if(typeof(modalTitle) != 'undefined' && modalTitle != null && $("#S_companyId").val() == ''){
									if(modalTitle.toLocaleLowerCase() === 'add new address'){
										digitalDataEvents.push( {uimsg:"Add New Address Modal | Enter your company name"});
									}
									if(modalTitle.toLocaleLowerCase() === 'edit delivery address'){
										digitalDataEvents.push( {uimsg:"Edit Address Modal | Enter your company name"});
									}
								}
								return true;
							}							
							return false;
						}							
					   	 else{
					   		return true;
					   	}
					}
					if(type == 'B'){
						if(shippingCountries[0] == "US" && isCompanyMandateEnabled === "true" && isLocalDelivery){
							if(typeof(modalTitle) != 'undefined' && modalTitle != null && $("#B_companyId").val() == ''){
								if(modalTitle.toLocaleLowerCase() === 'add new address'){
									digitalDataEvents.push( {uimsg:"Add New Address Modal | Enter your company name"});
								}
								if(modalTitle.toLocaleLowerCase() === 'edit billing address'){
									digitalDataEvents.push( {uimsg:"Edit Address Modal | Enter your company name"});
								}
							}
							return true;
						}
						return false;  
					}
				}
				// Was always false before change related to STRY0144246
				return false;		   
			}
			//Tries to reach the form. First attempt form parameter, second attempt throw COSTCO.CAddressForm.getForm. 
			//And if the form is not undefined, do validation
			let form;
			if (formToValidate != undefined) {
				form = formToValidate;
			}
			if (form == undefined && COSTCO.CAddressForm.getForm().length != 0) {
				form = COSTCO.CAddressForm.getForm();
			}
			if (form != undefined) {
				if (!isEditDefaultShippingAddress) {
				form.validate({
					rules : {
						firstModal : {required:getFirstLastNameRule(), firstNameValidation: true},
						lastModal : {required:getFirstLastNameRule(), lastNameValidation: true},
						country : "required",
						address1 : {required: true, maxlength: getAddressLine1MaxCharLength, pobox: true},
						address2 : {maxlength: 30, pobox: true},
						//company : {maxlength: 40, companyrequiredcheck: true},
						company : {required: isCompanyRequired(), maxlength: 40},
						postal : {required:true, countryspecificpostalcodePassCountrySelectorModal:true},
						city : "required",
						state : {required: true, notEqual:"NO_STATE_TYPE_SELECTED", hasvalidationerror: true, validateAdditionalTerritories: type},
						phone : {required: true, phone:true},
						email : {required: true, email: true, maxlength:254},
						deliveryInstructions: {required: false},
						contactName  : "required",
						contactPhone : "phone",
						ext1 : "digits"
					},
					messages : {
						firstModal : {required:messages.ERR_INVALID_FIRSTNAME, firstNameValidation:messages.ERR_INVALID_FNAME},
						lastModal : {required:messages.ERR_INVALID_LASTNAME, lastNameValidation:messages.ERR_INVALID_LNAME},
						country : messages.ERR_INVALID_COUNTRY,
						address1 : {required: messages.ERR_INVALID_STREETADDRESS, maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH_FRIENDLY_MESSAGE, pobox: messages.ERR_INVALID_POBOX},
						address2 : {maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH, pobox: messages.ERR_INVALID_POBOX},
						company : {maxlength: messages.ERR_INVALID_COMPANY_NAME_LENGTH,required:messages.ERR_COMPANY_REQUIRED,companyrequiredcheck: messages.ERR_INVALID_COMPANY},
						postal : messages.ERR_ENTER_ZIPCODE,
						city : messages.ERR_INVALID_CITY,
						state : messages.ERR_INVALID_STATE,
						phone : {required:messages.ERR_INVALID_PHONE1,phone:messages.ERR_INVALID_PHONE1},
						email : {required:messages.ERR_REQUIRED_EMAIL_MY, email:messages.ERR_INVALID_EMAIL, maxlength: messages.ERR_INVALID_EMAIL},
						contactName : messages.ERR_INVALID_CONTACT_NAME,
						contactPhone : messages.ERR_INVALID_PHONE1,
						ext1: messages.ERR_INVALID_EXTN_NUMBER
					},
					invalidHandler : COSTCO.util.invalid_handler,
					highlight: COSTCO.util.highlightWithErrorLabel,
					unhighlight: COSTCO.util.unhighlightWithErrorLabel,
					errorPlacement : function(error, element) {
						if (element.attr("name") == "state" ) {
							element.parent().addClass('error');
				      		error.insertAfter($('[name=state]').parent());
				    	} else if (element.attr("name") == "country" ) {
							element.parent().addClass('error');
				      		error.insertAfter($('[name=country]').parent());
				    	} else {
				      		error.insertAfter(element);
				    	}
				  	}
				}).form();
			} else {
				// validation rules and messages for edit default shipping address
				form.validate({
					rules : {
						firstModal : {required:getFirstLastNameRule(), firstNameValidation: true},
						lastModal : {required:getFirstLastNameRule(), lastNameValidation: true},
						country : "required",
						address1 : {required: true, maxlength: getAddressLine1MaxCharLength, pobox: true},
						address2 : {maxlength: 30, pobox: true},
						//company : {maxlength: 40, companyrequiredcheck: true},
						company : {required: isCompanyRequired(), maxlength: 40},
						postal : {required:true, countryspecificpostalcodePassCountrySelectorModal:true},
						city : "required",
						state : {required: true, notEqual:"NO_STATE_TYPE_SELECTED", hasvalidationerror: true, validateAdditionalTerritories: type},
						phone : {required: true, phone:true},
						email : {required: true, email: true, maxlength:254},
						deliveryInstructions: {required: false},
						contactName  : "required",
						contactPhone : "phone",
						ext1 : "digits"
					},
					messages : {
						firstModal : {required:messages.ERR_INVALID_FIRSTNAME, firstNameValidation:messages.ERR_INVALID_FNAME},
						lastModal : {required:messages.ERR_INVALID_LASTNAME, lastNameValidation:messages.ERR_INVALID_LNAME},
						country : messages.ERR_INVALID_COUNTRY,
						address1 : {required: messages.ERR_INVALID_STREETADDRESS, maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH_FRIENDLY_MESSAGE, pobox: messages.ERR_INVALID_POBOX},
						address2 : {maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH, pobox: messages.ERR_INVALID_POBOX},
						company : {maxlength: messages.ERR_INVALID_COMPANY_NAME_LENGTH,required:messages.ERR_INVALID_COMPANY,companyrequiredcheck: messages.ERR_INVALID_COMPANY},
						postal : messages.ERR_ENTER_ZIPCODE,
						city : messages.ERR_INVALID_CITY,
						state : messages.ERR_INVALID_STATE,
						phone : {required:messages.ERR_INVALID_PHONE2,phone:messages.ERR_INVALID_PHONE2},
						email : {required:messages.ERR_EMAIL_ADDRESS_REQUIRED, email:messages.ERR_INVALID_EMAIL, maxlength: messages.ERR_INVALID_EMAIL},
						contactName : messages.ERR_INVALID_CONTACT_NAME,
						contactPhone : messages.ERR_INVALID_PHONE1,
						ext1: messages.ERR_INVALID_EXTN_NUMBER
					},
					invalidHandler : COSTCO.util.invalid_handler,
					highlight: COSTCO.util.highlightWithErrorLabel,
					unhighlight: COSTCO.util.unhighlightWithErrorLabel,
					errorPlacement : function(error, element) {
						if (element.attr("name") == "state" ) {
							element.parent().addClass('error');
							  error.insertAfter($('[name=state]').parent());
						} else if (element.attr("name") == "country" ) {
							element.parent().addClass('error');
							  error.insertAfter($('[name=country]').parent());
						} else {
							  error.insertAfter(element);
						}
					  }
				}).form();
			}



				var selectsValid = true;

				form.find('.style-select > select').each(function() {
					$(this).unbind('change').change(function(){
						if($(this).val()==="NO_STATE_TYPE_SELECTED"){
							selectsValid=false;
							$(this).parent().addClass('error');
						}else{
							$(this).parent().removeClass('error');
							if($(this).attr('hasvalidationerror') != undefined && $(this).attr('hasvalidationerror') != null){
								$(this).attr('hasvalidationerror', false);
							}
						}
					})
				});


				form.find('.style-select > select').change();

				return (form.valid() && selectsValid);
			}
		},

		/*
		 * Build Address Array from a query selector
		 */
		buildAddressArray : function(type) {
			var addressObject = {};
			var addressArray = [];
			var _baseAddr = COSTCO.CAddressForm.getForm();
			let addressPrefix = '';
			
			if(_baseAddr.length > 0 && _baseAddr[0].id == 'quick-renew-address-form') {
				if(type == "S" || type == 'S')
					addressPrefix = 'shipping_';
				else
					addressPrefix = 'billing_';
			}

			addressObject['id'] = _baseAddr.find(`[name=${addressPrefix}addressId]`).val();
			addressObject['fName'] = _baseAddr.find(`[name=${addressPrefix}firstModal]`).val();
			addressObject['lName'] = _baseAddr.find(`[name=${addressPrefix}lastModal]`).val();
			addressObject['company'] = _baseAddr.find(`[name=${addressPrefix}company]`).val();
			addressObject['country'] = _baseAddr.find(`[name=${addressPrefix}country]`).val();
			addressObject['line1'] = _baseAddr.find(`[name=${addressPrefix}address1]`).val();
			addressObject['line2'] = _baseAddr.find(`[name=${addressPrefix}address2]`).val();
			addressObject['zip'] = _baseAddr.find(`[name=${addressPrefix}postal]`).val();
			addressObject['city'] = _baseAddr.find(`[name=${addressPrefix}city]`).val();
			addressObject['state'] = _baseAddr.find(`[name=${addressPrefix}state]`).val();
			addressObject['pNumber'] = _baseAddr.find(`[name=${addressPrefix}phone]`).unmask().val();
			addressObject['ext1'] = _baseAddr.find(`[name=${addressPrefix}ext1]`).val();
			addressObject['nickname'] = _baseAddr.find(`[name=${addressPrefix}nickname]`).val();
			addressObject['email'] = _baseAddr.find(`[name=${addressPrefix}email]`).val();
			addressObject['mInitial'] = _baseAddr.find(`[name=mInitial]`).val();
			addressObject['saveAddress'] = address.getSaveAddress(addressObject['id'],_baseAddr.find(`[name=${addressPrefix}save-address]:checked`).length>0);
			addressObject['setDefault'] = address.getDefaultAddress(addressObject['id'],_baseAddr.find(`[name=${addressPrefix}set-default]:checked`).length>0);
			addressObject['addressType'] = address.getAddressType(addressObject['id'],type);
			addressObject['addressType2'] = address.getAddressType(addressObject['id'],type);
			addressObject['deliveryInst'] = _baseAddr.find(`[name=${addressPrefix}deliveryInstructions]`).val();
			addressObject['contactName'] = _baseAddr.find(`[name=${addressPrefix}contactName]`).val();
			if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE === true) {
				addressObject['contactPhNo'] = _baseAddr.find(`[name=${addressPrefix}contactPhone]`).length > 0 ? _baseAddr.find(`[name=${addressPrefix}contactPhone]`).cleanVal() : _baseAddr.find(`[name=${addressPrefix}contactPhone]`).val();
			} else {
				addressObject['contactPhNo'] = _baseAddr.find(`[name=${addressPrefix}contactPhone]`).val();
			}
			addressObject['smsPhone'] = ($('#receiveSMS').is(':checked')) ? _baseAddr.find(`#${addressPrefix}smsPhoneId`).cleanVal() : "";

			if(addressObject.addressType == ''){
				addressObject.addressType = type;
			}

			addressArray.push(addressObject);
			return addressArray;
		},

		populateCityState : function(form, city, state, cityQuery, stateQuery){

			var form = $(form);
			
			var cityQueryNameValue = cityQuery.match(/\[name=(.*?)\]/)[1];
			var cityFieldType = COSTCO.CAddressForm.getCityFieldType(form,cityQueryNameValue);
			if(form.find('select'+cityQuery).length){
				COSTCO.CAddressForm.setCorrectCityField(form,cityQueryNameValue,cityFieldType);
			}

			form.find(cityQuery).val(city);
			form.find(stateQuery).val(state);
			form.find(cityQuery).focusout().change();
			form.find(stateQuery).focusout().change();
			//STRY0148134 checkout redesign - show city state inputs
			form.find('#'+ cityFieldType +'city-state').removeClass('hide');
		},

		matchCityOption : function(citySelect, editAddrCity){

			var options = citySelect.find('option');
			var matchingValue = null;
			var normalizedEditAddrCity = editAddrCity.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
			
			options.each(function () {
				var optionValue = $(this).val();
				var normalizedOptionValue = optionValue.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
				if (normalizedOptionValue == normalizedEditAddrCity) {
					matchingValue = optionValue;
					return false;
				}
			});
			
			return matchingValue;
		},
		
		/* ALM52674 - This method is used for the modal to display the correct city field type
		 * depending on the geo location service response - if the service is down, 
		 * a text input field is used, while if the service call is successful, a 
		 * select field with valid city options for the given zip/postal code is displayed
		*/
		setCorrectCityField : function(form,cityQueryNameValue,cityFieldType){
			
			var alternativeCityQueryNameValue = cityFieldType +'city2';
			
			//correctCityField is the city field that should be displayed, instead of the incorrectCityField
			var correctCityField = '[name='+alternativeCityQueryNameValue+']';
			var incorrectCityField = '[name='+cityQueryNameValue+']';
			
			/*whatever city field is displayed, it should have the idForCurrentCityField and nameForCurrentCityField
			values as the 'id', and 'name' attribute values, while the alternative field (not displayed) should have
			idForAltCityField and nameForAltCityField as 'id' and 'name'*/
			
			var idForCurrentCityField = form.find('[name='+cityQueryNameValue+']').attr('id');
			var idForAltCityField = form.find('[name='+alternativeCityQueryNameValue+']').attr('id');
			
			var nameForCurrentCityField = cityQueryNameValue;
			var nameForAltCityField = alternativeCityQueryNameValue;
			
			var parentDivId = cityFieldType+'city-state';
			
			var incorrParentDiv = form.find(incorrectCityField).parent();
			while(incorrParentDiv.attr('id') !== parentDivId){
				incorrParentDiv.addClass('hide');
				incorrParentDiv = incorrParentDiv.parent();
			}
			form.find(incorrectCityField).removeAttr('id required aria-required');
			
			var corrParentDiv = form.find(correctCityField).parent();
			while(corrParentDiv.attr('id') !== parentDivId){
				corrParentDiv.removeClass('hide');
				corrParentDiv = corrParentDiv.parent();
			}
			form.find(correctCityField).attr('id', idForCurrentCityField);
			form.find('#' + idForCurrentCityField).removeAttr('name required aria-required');
			form.find('#' + idForCurrentCityField).attr({
				'required' : 'true',
				'aria-required' : 'true'
				});
			
			form.find(incorrectCityField).attr('id',idForAltCityField);
			form.find('#'+ idForAltCityField).attr('name',nameForAltCityField);
			
			form.find('#'+ idForCurrentCityField).attr('name',nameForCurrentCityField);
			
			CAddressForm.moveMissplacedElements(form, idForAltCityField,idForCurrentCityField);
		},
		
		moveMissplacedElements : function(form, idForAltCityField,idForCurrentCityField){
			var altParentDiv = form.find('#'+ idForAltCityField).parent();
			var currElements  = altParentDiv.find('[for='+idForCurrentCityField+']');
			if(currElements.length){
				form.find('#' + idForCurrentCityField).parent().append(currElements);
			}
			return currElements;
		},

		/* SFSTRY0028209 - The address modal City and State fields will be displayed/populated
		 *  based on the geo location service response 
		*/
		populateCityStateForZipPostalCode : function(form, cityList, stateList, cityQuery, stateQuery, editAddrCity, editAddrState){

			var form = $(form);
			
			var editAddrCityOptionMatch = undefined;
			var cityQueryNameValue = cityQuery.match(/\[name=(.*?)\]/)[1];
			var cityFieldType = COSTCO.CAddressForm.getCityFieldType(form,cityQueryNameValue);
			
			if(cityList.length && stateList.length){
				
				if(form.find(cityQuery).attr('type') == "text"){
					COSTCO.CAddressForm.setCorrectCityField(form,cityQueryNameValue,cityFieldType);
				}
				var cityOptions = CAddressForm.getCityDropDown(cityList);
				
				var stateOptions = CAddressForm.getStateProvDropDown(stateList);
				form.find(cityQuery).empty().append(cityOptions);
				form.find(stateQuery).empty().append(stateOptions);
				
				if(editAddrCity != undefined){
					editAddrCityOptionMatch = COSTCO.CAddressForm.matchCityOption(form.find(cityQuery), editAddrCity);
				}
				
			} else {
				var stateProvList = address.getStateProvJson();
				var stateOptions = CAddressForm.getStateOptions(stateProvList);
				form.find(stateQuery).empty().append(stateOptions);
				form.find(cityQuery).empty();
				var alternativeCityQuery = '[name='+ cityFieldType +'city2]';
				if(form.find(alternativeCityQuery).length > 0 && form.find(alternativeCityQuery).attr('type') == "text"){
					COSTCO.CAddressForm.setCorrectCityField(form,cityQueryNameValue,cityFieldType);
				} else {
					form.find(cityQuery).val('');
				}
			}
			
			if(editAddrState != undefined && editAddrCity != undefined){
				var editAddrSavedCity = editAddrCityOptionMatch ? editAddrCityOptionMatch : editAddrCity;
				form.find(cityQuery).val(editAddrSavedCity);
				form.find(stateQuery).val(editAddrState);
			}
			
			form.find(cityQuery).focusout().change();
			form.find(stateQuery).focusout().change();
			//STRY0148134 checkout redesing - show city state inputs
			//form.find('#city-state').removeClass('hide');
			
			form.find('#'+ cityFieldType +'city-state').removeClass('hide');
			
		},
		
		/**
		 * Gets the City field form type 
		 */
		getCityFieldType : function(form,cityQueryNameValue) {
			var fieldType = '';
			if(cityQueryNameValue.indexOf('business') !== -1){
				fieldType = 'business_';
			} else if(cityQueryNameValue.indexOf('shipping') !== -1){
				fieldType = 'shipping_';
			} else if(cityQueryNameValue.indexOf('billing') !== -1){
				fieldType = 'billing_';
			} else if(cityQueryNameValue.indexOf('affiliate') !== -1 || form.attr('id').indexOf('affiliate') !== -1 ){
				fieldType = 'affiliate_'
			}
			
			return fieldType;
		},
		
		/**
		 * Gets shipping address id from html address display block
		 */
		getShippingId : function() {
			if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE === true && !(COSTCO.MembershipHelper.isQuickMembership)) {
				return $('#shipping .address-display').data('addressid');
			} else {
				return $('.address-display').data('addressid');
			}
			
		},

		/**
		 * Gets billing address id from html address display block
		 */
		getBillingId : function() {
			if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE === true && !(COSTCO.MembershipHelper.isQuickMembership)) {
				return $('#billing .address-display').data('addressid');
			} else {
				return $('.address-display').data('addressid');
			}
		},

		/**
		 * Checks if address form has been completed. For give address type if address block with address id is found on page,
		 * it is considered that address form is completed.
		 */
		isFormCompleted : function(type) {
			if (type === 'S') {
				return (this.getShippingId() != null);
			} else {
				return (this.getBillingId() != null);
			}			
		},
		initiatePopovers : function(){
			var helper = "#deliveryInstructionsPopover";
						
			var popOverSettings = {
				trigger:'focus',
			    placement: 'top',
			    html: true,
			    selector: helper,
			    content: function () {
			        return $(helper).data().popupcontent;
			    }
			}
			$('body').popover(popOverSettings);
		},
		showBusinessDeliveryQuestionnaireModal: function(type,data,action,addressOptions) {
			address.baseModal(type,'bdquestionnaire',{
				title: messages.BD_QUESTIONNAIRE_TITLE,
				body: COSTCO.util.tmpl('tmpl_bd_questionnaire_modal'),
				primary: messages.RWD_BD_QUESTIONNAIRE_AGREE,
				secondary: messages.JS_DIALOG_CANCEL,
				primary_event: function(){
				if(action == 'edit'){
					CAddressForm.openAddressAddModal(type, data, 'edit', addressOptions);
				}else{
					CAddressForm.openAddressAddModal(type, data, 'add',addressOptions);
				}
				}
	    	});
			
		},
		showBusinessDeliveryQuestionnaireModal_v2: function(type,data,action,addressOptions) {
			address.baseModal(type,'bdquestionnaire',{
				title: messages.BD_QUESTIONNAIRE_TITLE,
				body: COSTCO.util.tmpl('tmpl_bd_questionnaire_modal'),
				primary: messages.RWD_BD_QUESTIONNAIRE_AGREE,
				secondary: messages.JS_DIALOG_CANCEL,
				primary_event: function() {
					if (action == 'edit') {
						CAddressForm.openAddressAddModal_v2(type, data, 'edit', addressOptions);
					} else {
						CAddressForm.openAddressAddModal_v2(type, data, 'add',addressOptions);
					}
				}
			});
		},
		showBDQuestionnaireModalForInlineForm: function(type,preventHtmlReload,addressOptions,addressArray) {
			COSTCO.dialog.createExtDialogBox({
				title: messages.BD_QUESTIONNAIRE_TITLE,
				body: COSTCO.util.tmpl('tmpl_bd_questionnaire_modal'),
				primary: messages.RWD_BD_QUESTIONNAIRE_AGREE,
				secondary: messages.JS_DIALOG_CANCEL,
				primary_event: function(){
					CAddressForm.agreeFromBDQuestionnaireModal(type,preventHtmlReload,addressOptions,addressArray);
				}
			});
		},
		agreeFromBDQuestionnaireModal: function(type,preventHtmlReload,addressOptions,addressArray){
			addressOptions.successCallback = CAddressForm.addressVerifiedCallback;
	    	addressVerification.addressVerification(addressArray, type, preventHtmlReload, addressOptions);
		},
		//hides the link, shows input field
		showInputFiled: function(input) {
			let selectedElementParent = $(input).parent();
			selectedElementParent.siblings().removeClass('hide');
			selectedElementParent.siblings().find('input').focus();
			selectedElementParent.siblings().find('input').select();
			//timout set so that NVDA can focus the input field
			setTimeout(function(){
				selectedElementParent.addClass('hide');
			}, 120);
		},
		
		hideInputFiled: function(input) {
			$(input).parent().siblings().addClass('hide');
			$(input).parent().removeClass('hide');
		},
		
		/**
		 * This function is used to trigger character counting functionality
		 */
		countTextareaCharacters : function(element) {
			let additionalParam = $(element).data('param-type') !== undefined ? $(element).data('param-type') : null;
			$('body').trigger('count.delivery.inst.characters', additionalParam);
		},

		/**
		 * This function finds the textArea and character label and calls the character counting functionality
		 * @param {the expand element for the delivery instructions area} expandLink 
		 */
		countTextareaCharactersAddressBook: function(expandLink) {
			let textArea = $(expandLink).parent().siblings().find('textarea');
			let countLabel = textArea.siblings().find('#delivery-message-count');
			COSTCO.util.character_count(countLabel, textArea);
		},
		
		/**
		* This function is used to open edit block for Delivery Information
		*/
		showDeliveryInstructionsBlock: function (paramType) {
			$('#delivery-instructions-text').addClass('hide');
			$('#edit-delivery-instructions-text').removeClass('hide');
			let textAreaId = 'deliveryInstructions' + (paramType ? '-' + paramType : '');
			let textArea = $('#edit-delivery-instructions-text textarea[id=' + textAreaId + ']');
			textArea.attr('tabindex', 0);
			textArea.focus();
			textArea.select();
		},
		/**
		* This function is used to open edit block for Contact Information
		*/
		showContactInformationBlock: function () {
			$('#contact-information-text').addClass('hide');
			$('#edit-contact-information-text').removeClass('hide');
			if ($('input[id=contactPhNo-inline]').val() !== "") {
				$('label[for=contactPhNo-inline]').addClass('active');
			}
			if ($('input[id=contactName-inline]').val() !== "") {
				$('label[for=contactName-inline]').addClass('active');
			}
			$('#contactPhNo-inline').unmask().mask('000-000-0000');
		},
		/**
		* This function is used for updating different contact information for specific addressId
		* depending on xAddressInfoType (delivery instructions, contact name, contact phone etc.)
		*/
		updateXAddressInformation: function (inputElement, addressId) {
			let xAddressInfoType = $(inputElement).data('xaddress-info-type');
			let inputValue = $(inputElement).val();
			let preventHtmlResponse = false;
			let nextElement = event.relatedTarget;
			if (nextElement !== null) {
				if (nextElement.name === "contactPhone" || nextElement.name === "contactName") {
					preventHtmlResponse = true;
				}
			}
			let data = [{
				name: "addressId",
				value: addressId || ""
				}, {
				name: "xAddressInfoType",
				value: xAddressInfoType || ""
				}, {
				name: "inputValue",
				value: inputValue || ""
				}, {
				name: "preventHtmlResponse",
				value: preventHtmlResponse
			}];

			COSTCO.AjaxModular.ajax_update_state({
				url: 'AjaxXAddressUpdateCmd',
				method: 'POST',
				dataType: 'json',
				data: data,
				scrollToError: false,
				done: function(data, textStatus, jqXHR, options) {
					COSTCO.AjaxModular.ajax_update_default_done(data, textStatus, jqXHR, options);
					for (let i=0; i < COSTCO.util.addresses.length; i++) {
						if (COSTCO.util.addresses[i] !== undefined && COSTCO.util.addresses[i]["addressType"] === 'S') {
							COSTCO.util.addresses[i][xAddressInfoType] = inputValue;
						}
					}
				},
				always: function() {
					if (COSTCO.CreditCard !== undefined) {
						COSTCO.CreditCard.initComplete = false;
					}
					if (COSTCO.util.isBusinessDelivery()) {
						COSTCO.Header.miniShopCartRefresh();
						COSTCO.preauthchargesmodal.init();
					}
				}
			});
		},
		validateContactInformation: function() {
				if ($.validator.methods.contactInformationPhone === undefined) {
					$.validator.addMethod("contactInformationPhone", function(value, element) {
						if (value.startsWith("0") || value.startsWith("1")) {
							return false;
						}
						return this.optional(element) || /^\(?\d{3}\)?[ -.]?\d{3}[ -.]?\d{4}$/.test(value);
					}, messages.ERR_INVALID_PHONE1);
				}
				let form = $('#contact-information-form');
				form.validate({
					rules: {
						contactName  : {required: true, maxlength: 40},
						contactPhone : {contactInformationPhone: true}
					},
					messages: {
						contactName : messages.ERR_INVALID_CONTACT_NAME,
						contactPhone : messages.ERR_INVALID_PHONE1,
					},
					invalidHandler: COSTCO.util.invalid_handler,
					highlight: COSTCO.util.highlightWithErrorLabel,
					unhighlight: COSTCO.util.unhighlightWithErrorLabel,
					errorPlacement: function(error, element) {
						error.insertAfter(element);
					}
				});
				
					return form.valid();
			},
			updateContactInformation: function(inputElement, addressId){
				if(COSTCO.CAddressForm.validateContactInformation()){
					CAddressForm.updateXAddressInformation(inputElement, addressId);
				}
			},	
			
		toggleSmsBlock : function() {
	    	if($('#receiveSMS').is(':checked')) {
	    		$('.smsPhoneBlock').removeClass('hidden');
	    	} else {
	    		$('.smsPhoneBlock').addClass('hidden');
	    	}
		},
		/*
		 * QuestionnaireModal for BD National Delivery version 2
		 */
		showNationalDeliveryQuestionnaireModal: function(verifiedAddress, preventhtmlajax, addressOptions, message, userSelection) {
			var deliveryMethod;
			if($('input[name="deliveryMethod"]').length>0){
				deliveryMethod = $("input[name='deliveryMethod']:checked").val();
			}else if($('#shipmodeId').length>0){
				deliveryMethod = parseFloat($('#shipmodeId').val());
		}
			let delObj ={
				espotContent: deliveryMethod
	}
			var template = COSTCO.util.tmpl('tmpl_bd_questionnaire_modal', delObj);
			address.baseModal('S','bdquestionnaire',{
				title: messages.BD_QUESTIONNAIRE_TITLE,
				body: template,
				primary: messages.RWD_BD_QUESTIONNAIRE_AGREE,
				secondary: messages.JS_DIALOG_CANCEL,
				primary_event: function(){
					verifiedAddress.userAddressType = userSelection;
					address.addEditAddress(verifiedAddress, preventhtmlajax, addressOptions, message);
				}
	    	});
		},
		/*
		 * QuestionnaireModal for BD National Delivery
		 */
		showNationalDeliveryQuestionnaireModal_v2: function(form, data, params, verifiedAddress) {
			var deliveryMethod;
			if($('input[name="deliveryMethod"]').length>0){
				deliveryMethod = $("input[name='deliveryMethod']:checked").val();
			}else if($('#shipmodeId').length>0){
				deliveryMethod = parseFloat($('#shipmodeId').val());
			}
			let delObj ={
				espotContent: deliveryMethod
			}
			var template = COSTCO.util.tmpl('tmpl_bd_questionnaire_modal', delObj);
			address.baseModal('S','bdquestionnaire',{
				title: messages.BD_QUESTIONNAIRE_TITLE,
				body: template,
				primary: messages.RWD_BD_QUESTIONNAIRE_AGREE,
				secondary: messages.JS_DIALOG_CANCEL,
				primary_event: function(){
					if (typeof checkoutPage !== 'undefined') {
						if (checkoutPage=='review' || checkoutPage=='shipping' ) {
							isCheckoutFlow = true;
						}
					}
					if (isCheckoutFlow && !verifiedAddress) {
	                  COSTCO.zipCodeModal.buttonClickChange(data.SetDeliveryZip,form,params, data);
					} else if(isCheckoutFlow && !data.WarehouseChange && data.StatusMessage == data.ZipStatusMessageList[7]) {
						COSTCO.zipCodeModal.buttonClickChange(data.SetDeliveryZip, form, params, data, verifiedAddress);
					} else {
						COSTCO.zipCodeModal.changeZip_buttonClickChange(data, params, form, verifiedAddress);
					}
				}
			});
		},
		/**
		 * Reads 'Form End' when focus gets out of form
		 * @param formElement - form
		 */
		makeFormAdaCompatible: function(formElement) {
			if (formElement == undefined) {
				return false;
			}
			//Adds event on all focusable elements of form
			formElement.find('a, input, select').each(function(){
				$(this).blur(function() {
					setTimeout(function(){ //timeout is needed to wait for setting focus on next element
						if(!$.contains(formElement.get(0), document.activeElement)) {
							COSTCO.util.announceSRMessage(messages.FORM_END);
						}
					}, 30);
				});
			});
		},

		//Adds analytics for save/cancel/remove address buttons on the address form. 
		updateAddressModal: function() {
			let modalTitle = document.getElementById('costcoModalTitle');
			let modalBtn1 = document.getElementById('costcoModalBtn1');
			let modalBtn2 = document.getElementById('costcoModalBtn2');

			if (typeof(modalTitle) != 'undefined' && modalTitle != null)
    		{
				var text = modalTitle.innerText;
			}

			if (typeof(modalBtn1) != 'undefined' && modalBtn1 != null) {
				$('#costcoModalBtn1').attr("data-bi-tc", "ui:My Account | Address Book | Cancel Address");
			}
			if (typeof(modalBtn2) != 'undefined' && modalBtn2 != null) {

				if (text.toLocaleLowerCase() === 'edit shipping address' || text.toLocaleLowerCase() === 'add new address') {
					$('#costcoModalBtn2').attr("data-bi-tc", "ui:My Account | Address Book | Save Address")
				}

				if (text.toLocaleLowerCase() === 'remove address') {
					$('#costcoModalBtn2').attr("data-bi-tc", "ui:My Account | Address Book | Remove Address")
				}
			}
		}
	}

	if (typeof window.COSTCO === "undefined") {
		window.COSTCO = new Object();
	}
	window.COSTCO.CAddressForm = CAddressForm;
	return CAddressForm;
});



// WEBPACK FOOTER //
// ./js/address/addressForm.js